// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import {getDatabase} from "firebase/database"
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
    apiKey: "AIzaSyAOX8_bR5FUhDVRbIIG123AhNKtmtExqwo",
    authDomain: "apcs-board.firebaseapp.com",
    databaseURL: "https://apcs-board-default-rtdb.asia-southeast1.firebasedatabase.app",
    projectId: "apcs-board",
    storageBucket: "apcs-board.appspot.com",
    messagingSenderId: "968638957472",
    appId: "1:968638957472:web:03b2760d95d21388e606c5"
  };

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const db=getDatabase(app)